import Icon from "@ant-design/icons";

const FlowerSvg = () => (
    <svg width="1em" height="1em" viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50.0029" cy="50.0029" r="8.5" transform="rotate(90.0166 50.0029 50.0029)" stroke="black"/>
    <g clipPath="url(#clip0)">
    <path d="M43.5116 20.001C43.507 35.7411 56.2632 48.5047 72.0033 48.5093C87.7434 48.5138 100.507 35.7576 100.512 20.0175C100.516 4.2774 87.7599 -8.48617 72.0198 -8.49073C56.2797 -8.49528 43.5161 4.26091 43.5116 20.001Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip1)">
    <path d="M56.5116 20.0048C56.5161 4.26465 43.7599 -8.49892 28.0198 -8.50347C12.2797 -8.50803 -0.483877 4.24817 -0.48843 19.9883C-0.492983 35.7284 12.2632 48.492 28.0033 48.4965C43.7434 48.5011 56.507 35.7449 56.5116 20.0048Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip2)">
    <path d="M43.4942 80.001C43.4897 95.7411 56.2459 108.505 71.986 108.509C87.7261 108.514 100.49 95.7576 100.494 80.0175C100.499 64.2774 87.7426 51.5138 72.0025 51.5093C56.2623 51.5047 43.4988 64.2609 43.4942 80.001Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip3)">
    <path d="M56.4942 80.0048C56.4988 64.2647 43.7426 51.5011 28.0024 51.4965C12.2623 51.492 -0.501241 64.2482 -0.505794 79.9883C-0.510347 95.7284 12.2458 108.492 27.986 108.497C43.7261 108.501 56.4897 95.7449 56.4942 80.0048Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip4)">
    <path d="M20.001 56.4942C35.7411 56.4988 48.5047 43.7426 48.5093 28.0025C48.5138 12.2624 35.7576 -0.501211 20.0175 -0.505764C4.2774 -0.510317 -8.48617 12.2459 -8.49073 27.986C-8.49528 43.7261 4.26091 56.4897 20.001 56.4942Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip5)">
    <path d="M20.0048 43.4943C4.26467 43.4897 -8.49891 56.2459 -8.50346 71.986C-8.50801 87.7261 4.24818 100.49 19.9883 100.494C35.7284 100.499 48.492 87.7426 48.4965 72.0025C48.5011 56.2624 35.7449 43.4988 20.0048 43.4943Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip6)">
    <path d="M80.001 56.5116C95.7411 56.5162 108.505 43.76 108.509 28.0198C108.514 12.2797 95.7576 -0.483846 80.0175 -0.488399C64.2774 -0.492952 51.5138 12.2632 51.5093 28.0034C51.5047 43.7435 64.2609 56.507 80.001 56.5116Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip7)">
    <path d="M80.0048 43.5116C64.2647 43.5071 51.5011 56.2633 51.4965 72.0034C51.492 87.7435 64.2482 100.507 79.9883 100.512C95.7284 100.516 108.492 87.76 108.497 72.0199C108.501 56.2798 95.7449 43.5162 80.0048 43.5116Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip8)">
    <path d="M24.1983 33.3784C35.3251 44.5116 53.3703 44.5168 64.5034 33.3901C75.6366 22.2634 75.6418 4.21817 64.5151 -6.91499C53.3884 -18.0482 35.3432 -18.0534 24.21 -6.92665C13.0768 4.20007 13.0716 22.2453 24.1983 33.3784Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip9)">
    <path d="M33.3934 24.1887C22.2667 13.0555 4.22147 13.0503 -6.91169 24.177C-18.0449 35.3037 -18.0501 53.3489 -6.92335 64.4821C4.20337 75.6153 22.2486 75.6205 33.3817 64.4938C44.5149 53.367 44.5201 35.3218 33.3934 24.1887Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip10)">
    <path d="M66.6125 75.8171C77.7392 86.9503 95.7844 86.9555 106.918 75.8288C118.051 64.7021 118.056 46.6569 106.929 35.5237C95.8025 24.3905 77.7573 24.3853 66.6241 35.512C55.491 46.6388 55.4857 64.684 66.6125 75.8171Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip11)">
    <path d="M75.8075 66.6274C64.6808 55.4942 46.6356 55.489 35.5024 66.6157C24.3693 77.7424 24.364 95.7876 35.4908 106.921C46.6175 118.054 64.6627 118.059 75.7959 106.932C86.929 95.8057 86.9342 77.7605 75.8075 66.6274Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip12)">
    <path d="M33.3785 75.8075C44.5116 64.6807 44.5168 46.6355 33.3901 35.5024C22.2634 24.3692 4.2182 24.364 -6.91496 35.4907C-18.0481 46.6174 -18.0533 64.6626 -6.92662 75.7958C4.2001 86.929 22.2453 86.9342 33.3785 75.8075Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip13)">
    <path d="M24.1887 66.6124C13.0556 77.7391 13.0503 95.7843 24.1771 106.917C35.3038 118.051 53.349 118.056 64.4821 106.929C75.6153 95.8024 75.6205 77.7572 64.4938 66.624C53.3671 55.4909 35.3219 55.4857 24.1887 66.6124Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip14)">
    <path d="M75.8171 33.3933C86.9503 22.2666 86.9555 4.22141 75.8288 -6.91176C64.7021 -18.0449 46.6569 -18.0501 35.5237 -6.92342C24.3905 4.20331 24.3853 22.2485 35.512 33.3817C46.6388 44.5148 64.684 44.5201 75.8171 33.3933Z" stroke="white" strokeWidth="5"/>
    </g>
    <g clipPath="url(#clip15)">
    <path d="M66.6274 24.1983C55.4942 35.325 55.489 53.3702 66.6157 64.5033C77.7425 75.6365 95.7877 75.6417 106.921 64.515C118.054 53.3883 118.059 35.3431 106.932 24.2099C95.8058 13.0768 77.7606 13.0715 66.6274 24.1983Z" stroke="white" strokeWidth="5"/>
    </g>
    <circle cx="50.0029" cy="50.0029" r="7.5" transform="rotate(45.0184 50.0029 50.0029)" stroke="white"/>
    <defs>
    <clipPath id="clip0">
    <rect width="40" height="10" fill="white" transform="translate(50.0173 0.00289917) rotate(90.0166)"/>
    </clipPath>
    <clipPath id="clip1">
    <rect width="40" height="10" fill="white" transform="translate(50.0058 40.0029) rotate(-89.9834)"/>
    </clipPath>
    <clipPath id="clip2">
    <rect width="40" height="10" fill="white" transform="translate(50 60.0029) rotate(90.0166)"/>
    </clipPath>
    <clipPath id="clip3">
    <rect width="40" height="10" fill="white" transform="translate(49.9884 100.003) rotate(-89.9834)"/>
    </clipPath>
    <clipPath id="clip4">
    <rect width="40" height="10" fill="white" transform="translate(0.00289917 49.9885) rotate(0.0165735)"/>
    </clipPath>
    <clipPath id="clip5">
    <rect width="40" height="10" fill="white" transform="translate(40.0029 50) rotate(-179.983)"/>
    </clipPath>
    <clipPath id="clip6">
    <rect width="40" height="10" fill="white" transform="translate(60.0029 50.0058) rotate(0.0165735)"/>
    </clipPath>
    <clipPath id="clip7">
    <rect width="40" height="10" fill="white" transform="translate(100.003 50.0174) rotate(-179.983)"/>
    </clipPath>
    <clipPath id="clip8">
    <rect width="40" height="10" fill="white" transform="translate(14.6578 14.6373) rotate(45.0166)"/>
    </clipPath>
    <clipPath id="clip9">
    <rect width="40" height="10" fill="white" transform="translate(42.9339 42.9298) rotate(-134.983)"/>
    </clipPath>
    <clipPath id="clip10">
    <rect width="40" height="10" fill="white" transform="translate(57.0719 57.076) rotate(45.0166)"/>
    </clipPath>
    <clipPath id="clip11">
    <rect width="40" height="10" fill="white" transform="translate(85.348 85.3685) rotate(-134.983)"/>
    </clipPath>
    <clipPath id="clip12">
    <rect width="40" height="10" fill="white" transform="translate(14.6374 85.348) rotate(-44.9834)"/>
    </clipPath>
    <clipPath id="clip13">
    <rect width="40" height="10" fill="white" transform="translate(42.9298 57.0719) rotate(135.017)"/>
    </clipPath>
    <clipPath id="clip14">
    <rect width="40" height="10" fill="white" transform="translate(57.076 42.9338) rotate(-44.9834)"/>
    </clipPath>
    <clipPath id="clip15">
    <rect width="40" height="10" fill="white" transform="translate(85.3685 14.6577) rotate(135.017)"/>
    </clipPath>
    </defs>
    </svg> 
);

const FlowerIcon = props => <Icon component={FlowerSvg} {...props} />;

export default FlowerIcon;



